export type EpSurveyDocumentBlock =
    | { kind: 'heading'; text: string; level: number }
    | { kind: 'paragraph'; text: string }
    | { kind: 'list'; ordered: boolean; start: number; items: string[] }
    | { kind: 'table'; headers: string[]; rows: string[][] };

export const epSurveyPlainText = (value: string) => value
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '$1 ($2)')
    .replace(/\*\*([^*]+)\*\*|__([^_]+)__/g, '$1$2')
    .replace(/`([^`]+)`/g, '$1');
const cells = (line: string) => line.trim().replace(/^\||\|$/g, '').split(/(?<!\\)\|/).map(cell => epSurveyPlainText(cell.trim().replace(/\\\|/g, '|')));
const tableRule = (line: string) => line.includes('|') && cells(line).every(cell => /^:?-{3,}:?$/.test(cell));

export function epSurveyDocumentBlocks(value: string): EpSurveyDocumentBlock[] {
    const lines = value.replace(/\\n/g, '\n').split(/\r?\n/);
    const blocks: EpSurveyDocumentBlock[] = [];
    let paragraph: string[] = [];
    const flush = () => {
        if (paragraph.length)
            blocks.push({ kind: 'paragraph', text: epSurveyPlainText(paragraph.join('\n')) });
        paragraph = [];
    };
    for (let index = 0; index < lines.length; index++) {
        const line = lines[index].trim();
        if (!line || /^```/.test(line) || /^([-*_])\1{2,}$/.test(line)) {
            flush();
            continue;
        }
        if (line.includes('|') && index + 1 < lines.length && tableRule(lines[index + 1])) {
            flush();
            const headers = cells(line);
            const rows: string[][] = [];
            index++;
            while (index + 1 < lines.length && lines[index + 1].trim().includes('|')) {
                const row = cells(lines[++index]);
                rows.push(headers.map((_, column) => row[column] || ''));
                if (row.length > headers.length)
                    rows[rows.length - 1][headers.length - 1] += ` | ${row.slice(headers.length).join(' | ')}`;
            }
            blocks.push({ kind: 'table', headers, rows });
            continue;
        }
        const heading = /^(#{1,6})\s+(.+?)\s*#*$/.exec(line);
        if (heading) {
            flush();
            blocks.push({ kind: 'heading', text: epSurveyPlainText(heading[2]), level: heading[1].length });
            continue;
        }
        const item = /^(?:([-*+•])|(\d+)[.)])\s+(.+)$/.exec(line);
        if (item) {
            flush();
            const ordered = Boolean(item[2]);
            const previous = blocks[blocks.length - 1];
            if (previous?.kind === 'list' && previous.ordered === ordered && (!ordered || Number(item[2]) === previous.start + previous.items.length))
                previous.items.push(epSurveyPlainText(item[3]));
            else
                blocks.push({ kind: 'list', ordered, start: ordered ? Number(item[2]) : 1, items: [epSurveyPlainText(item[3])] });
            continue;
        }
        paragraph.push(line);
    }
    flush();
    return blocks;
}
